import controller from './doctor-advance-filter-options.controller'
import template from './doctor-advance-filter-options.html'
import './doctor-advance-filter-options.scss'

const DoctorAdvanceFilterOptionsComponent = {
	bindings: {
		languages: '<',
		selectedLanguage: '<',
		timeBeforeOption: '<',
		timeAfterOption: '<',
		childrenOption: '<',
		onChange: '&',
		language: '<'
	},
	controller,
	template,
};

export default DoctorAdvanceFilterOptionsComponent;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/doctor-advance-filter-options/doctor-advance-filter-options.component.js